import axiosInstance from "./axiosInstance";

export const getAllEnquiries = async () => {
    try {
        const response = await axiosInstance.get("/enquiry", {
            headers: { authType: "PostLogin" },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.token || "Failed to fetch enquiry");
    }
};

export const getEnquiryById = async (id) => {
    try {
        const response = await axiosInstance.get(`/enquiry/${id}`, {
            headers: { authType: "PostLogin" },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.token || "Failed to fetch enquiry");
    }
};

export const createEnquiry = async (formData) => {
    try {
        const response = await axiosInstance.post("/public/enquiry", formData, {
            headers: {
                "Content-Type": "application/json",
                authType: "PreLogin",
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.token || "Failed to create contact");
    }
};

export const deleteEnquiry = async (id) => {
    try {
        const response = await axiosInstance.delete(`/deleted/${id}`, {
            headers: { authType: "PostLogin" },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.token || "Failed to delete enquiry");
    }
};